<template>
  <div>
    <b-card>
      <div class="container-fluid">
        <div class="row terms-and-conditions-section">
          <div class="col-md-12">
            <h1 class="title">Terms and Conditions</h1>
          </div>

          <div class="col-xs-12 col-sm-10 col-md-12">
            <div class="content">
              <p>
                Xmartlabs, SRL ("Xmartlabs") operates Project Hub (as defined
                below), your use of Project Hub is governed by these Terms of
                Service (“Terms”), and your use of Project Hub constitutes your
                acceptance of the Terms.
              </p>
              <p>
                "Project Hub" (the "Service") means Project Hub project
                management solution made available at
                <a href="https://tryprojecthub.com"
                  >https://tryprojecthub.com</a
                >
                (the “Site”) and any other software, sites, and services offered
                by Xmartlabs in connection therewith but does not include any
                sites, services, products, or offerings governed by other terms
                of use, or, other agreements between you and Xmartlabs.
                "Customer Data" means any data you make available to Xmartlabs
                or Project Hub from your GitHub account for the purpose of using
                Project Hub. "Content" means all content generated by Xmartlabs
                on your behalf (including metric data) and does not include
                Customer Data.
              </p>
              <p>
                We will endeavor to provide you with notice about major changes
                to the Terms or Project Hub and other changes (via email to the
                address on your account), but we make no guarantees. Other
                changes could be, without limitation, changes to payment
                policies, security patches, added or removed functionality, and
                other enhancements or restrictions to Project Hub. Your use of
                Project Hub after the Terms have changed constitutes your
                acceptance of the Terms as changed. You may reject changes to
                the Terms by terminating your subscription in accordance with
                the "Cancellation and Termination" section of these Terms of
                Service. Xmartlabs shall not be liable to you or to any third
                party for any change to Project Hub.
              </p>
              <p>
                Please use Project Hub responsibly and in compliance with these
                Terms. If you don't, we reserve the right to terminate your
                subscription in accordance with the "Cancellation and
                Termination" section of these Terms of Service.
              </p>

              <h2 class="section-title">1. Use of Project Hub</h2>
              <p>
                To use Project Hub, you must (i) have a GitHub account (ii)
                authorize Xmartlabs to access your Customer Data to provide
                Project Hub, (iii) provide accurate GitHub account information
                any time you register to use Project Hub, (iv) provide accurate
                GitHub account information when you register to use Project Hub,
                and (v) be a human over the age of 13. Uses by automated methods
                are not permitted. You grant Xmartlabs a non-exclusive,
                royalty-free, and worldwide license to use, store, and copy your
                Customer Data in order to provide Project Hub.
              </p>
              <p>
                You are responsible for the security of your passwords and for
                any use of your account. You may not allow multiple people to
                use the same account or otherwise access Project Hub in a manner
                intended to avoid incurring fees.
              </p>
              <p>
                You must comply with all applicable GitHub policies and terms of
                service. Xmartlabs is not responsible for any acts or omissions
                of GitHub whether related to your account or otherwise.
              </p>
              <p>
                Xmartlabs reserves the right to enforce quotas and usage limits
                (to any resources, including the API) at its sole discretion,
                with or without notice, which may result in Xmartlabs disabling
                or throttling your usage of the Service for any amount of time.
              </p>
              <p>
                You are responsible for obtaining access to Project Hub and that
                access may involve third party fees (such as Internet service
                provider or airtime charges). You are responsible for those
                fees. In addition, you must provide and are responsible for all
                equipment necessary to access the Site.
              </p>
              <p>You may not use Project Hub:</p>
              <ul>
                <li>
                  for any illegal purpose, in any manner inconsistent with
                  applicable laws, regulations, or ordinances, or to submit,
                  post, upload, or otherwise transmit any Customer Data or
                  Content that is unlawful, defamatory, libelous, invasive of
                  another's privacy, abusive, threatening, harassing, vulgar,
                  obscene, indecent or otherwise objectionable;
                </li>
                <li>
                  to submit, post, upload or otherwise transmit any Customer
                  Data or Content that infringes or otherwise violates the
                  rights of any third party, including without limitation
                  privacy rights, fiduciary rights and proprietary rights;
                </li>
                <li>
                  to submit, post, upload or otherwise transmit Customer Data or
                  Content that contains viruses, corrupted files, or any other
                  similar software or programs that may damage the operation of
                  Project Hub or another person's computer; or
                </li>
                <li>
                  if you are a person barred from receiving Project Hub under
                  the laws of the United States or other countries, including
                  the country in which you are resident or from which you use
                  Project Hub.
                </li>
              </ul>

              <div class="col-12 col-md-12 my-3">
                <div class="form-group">
                  <div class="flex items-center">
                    <vs-checkbox
                      class="ml-3"
                      v-validate="'required'"
                      name="terms"
                      v-model="terms"
                    />
                    <b>{{ $t("TermsText1") }}</b>
                  </div>
                  <span
                    class="text-danger text-sm"
                    style="margin-left: 17px"
                    v-show="termsError"
                    >{{ $t("TermsError") }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.text-center {
  text-align: center !important;
}
</style>